<template>
  <b-container>
    <b-container fluid style="padding-top: 20px">
      <b-card bg-variant="light">
        <b-form-group label-cols="4" label-cols-lg="2" label-size="md" label="First Name" label-for="input-sm">
          <b-form-input id="input-sm" size="sm" v-model="firstName"/>
        </b-form-group>

        <b-form-group label-cols="4" label-cols-lg="2" label-size="md" label="Last Name" label-for="input-sm">
          <b-form-input id="input-sm" size="sm" v-model="lastName"/>
        </b-form-group>

        <b-form-group label-cols="4" label-cols-lg="2" label-size="md" label="Telephone Number"
                      label-for="input-sm">
          <b-form-input id="telephoneNumber" size="sm" v-model="telephoneNumber"/>
        </b-form-group>

        <b-form-group label-cols="4" label-cols-lg="2" label-size="md" label="Company" label-for="input-sm">
          <b-form-input id="input-sm" size="sm" v-model="company"/>
        </b-form-group>

        <b-form-group label-cols="4" label-cols-lg="2" label-size="md" label="Email " label-for="input-sm">
          <b-form-input id="input-sm" size="sm" v-model="email"/>
        </b-form-group>

        <b-form-group label-cols="4" label-cols-lg="2" label-size="md" label="Username" label-for="input-sm">
          <b-form-input id="input-sm" size="sm" v-model="username"/>
        </b-form-group>
        <b-form-group vi="shouldDisplayDefaultTemplateGroup" label-cols="4" label-cols-lg="2" label-size="md"
                      label="Default Group" label-for="default-gorup">
          <b-form-select
              v-model="defaultTemplateGroup"
              :options="organizationList"
              value-field="_id"
              text-field="name"
          >

          </b-form-select>
        </b-form-group>
        <b-container fluid>
          <div class="button-holder">
            <b-button class="submit-button" type="submit" @click="submit('userInfo')" variant="primary">
              Submit
            </b-button>

            <b-button class="cancel-button" type="cancel" @click="cancel" variant="primary">Cancel
            </b-button>
          </div>
        </b-container>
      </b-card>
    </b-container>
  </b-container>

</template>

<script>

const emailRegex = /^([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/i;

export default {
  name: "UserSignUp.vue",
  props: {
    groupId: String
  },
  data() {
    return {
      myGroupId: this.groupId || localStorage.getItem('adminImpersonationGroupId') || localStorage.getItem('groupId'),
      firstName: '',
      lastName: '',
      telephoneNumber: '',
      company: '',
      streetAddress: '',
      city: '',
      state: '',
      zipCode: '',
      id: '',
      username: '',
      email: '',
      errors: [],
      groupId: '',
      businessName: '',
      businessAddress: '',
      requiredText: "*Required",
      primaryContact: '',
      contactTelephoneNumber: '',
      contactEmail: '',
      wasteProvider: '',
      waterSupplySource: '',
      wiesSelected: '',
      trackableWaterMeter: '',
      onSiteBottling: '',
      renewableEnergy: '',
      renewableEnergySelected: [],
      renewableEnergyOptions: ["Solar (at Winery)", "Solar (at Vineyard)", "Geothermal", "Wind", "Microturbine"],
      evChargingStations: '',
      environmentalCertifications: [],
      environmentalCertificationsOptions: ["CCSW", "LEED", "Organic", "Demeter Biodynamic"],
      yesNoOptions: ["Yes", "No"],
      featuresSelected: [],
      featuresOptions: ["Barrel cellar", "Caves", "On Site Bottling", "Winery Tasting Room", "Offsite Tasting Room"
        , "Onsite Kitchen", "Barrel Cleaning Machine"],
      wasteWaterSelected: [],
      wasteWaterTreatmentOptions: ["Pond(s)", "Leach", "Packaged treatment system", "Hold and Haul"],
      organizationList: [{text: "First Operation", value: '123edaf34de'}, {
        text: "Second Operation",
        value: '123edaf34df'
      }],
      defaultTemplateGroup: '',
      isSubmitted: true

    }
  },
  computed: {
    validateBusinessName: function () {
      let isValid = this.businessName !== "Business Name" && this.businessName !== '';
      console.log("Business Name valid: " + isValid);
      return isValid;
    },
    validateBusinessAddress: function () {
      let isValid = this.businessAddress !== "Business Address" && this.businessAddress !== '';
      console.log("Business Name valid: " + isValid);
      return isValid;
    },
    validateContactName: function () {
      let isValid = this.primaryContact !== "Contact Name" && this.primaryContact !== '';
      console.log("Business Name valid: " + isValid);
      return isValid;
    },
    validateContactTelephoneNumber: function () {
      let isValid = this.contactTelephoneNumber !== "Telephone" && this.contactTelephoneNumber !== '';
      console.log("Business Name valid: " + isValid);
      return isValid;
    },
    validateContactEmail: function () {
      let isValid = this.validateEmailAddress(this.contactEmail);
      console.log("Email Address valid: " + isValid);
      return isValid;
    },
    canSubmit: function () {
      return this.validateContactEmail && this.validateContactTelephoneNumber
          && this.validateContactName && this.validateBusinessAddress && this.validateBusinessName;
    }
  },
  beforeMount() {
    this.loadGroups();
  },
  mounted() {
    console.log("About To mount");
    this.$http.get("account/user/" + localStorage.getItem("user"))
        .then(response => {
          let user = response.data;
          this.firstName = user.firstName;
          this.lastName = user.lastName;
          this.telephoneNumber = user.telephoneNumber;
          this.company = user.company;
          this.streetAddress = user.streetAddress;
          this.city = user.city;
          this.state = user.state;
          this.zipCode = user.zipCode;
          this.id = user.id;
          this.username = user.username;
          this.email = user.email;
          this.defaultTemplateGroup = user.defaultTemplateGroup;
        });
  },
  methods:
      {
        shouldDisplayDefaultTemplateGroup: function () {
          return this.organizationList
              .filter(org => org.entityType === "VINEYARD").length > 0 && !this.isAdmin
        },
        loadGroups: function () {
          this.$http.get("account/user/" + localStorage.getItem("user") + "/groups")
              .then(result => {
                this.organizationList = result.data.filter(org => org.entityType === "VINEYARD");
                console.log(this.requests)
              })
              .catch(error => {
                console.log("Couldn't Retrieve Requests", error.message);
              })
        },
        validateEmail: function (mail) {
          if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
            return true;
          }
          alert("You have entered an invalid email address!");
          return false;
        },
        validateEmailAddress: function (email) {
          //let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return emailRegex.test(String(email).toLowerCase());
        },
        isFieldValid: function (fieldValue, defaultValue) {
          console.log(Object.keys(fieldValue));
          return fieldValue !== defaultValue && fieldValue !== "";
        },
        validateForm: function (self, data) {
          return self.validateEmailAddress(data.contactEmail)
              && self.isFieldValid(data.contactName, "Contact Name")
              && self.isFieldValid(data.contactTelephoneNumber, "Telephone")
              && self.isFieldValid(data.contactEmail, "Contact Email")
              && self.isFieldValid(data.businessName, "Business Name")
              && self.isFieldValid(data.businessAddress, "Business Address");
        },
        buildValidationMessage: function () {
          return "Please enter a valid email address.";
        },
        submit: function (formName) {
          let data;
          let url;
          let self = this;
          if (formName === "userInfo") {
            url = 'account';
            data = {
              firstName: this.firstName,
              lastName: this.lastName,
              telephoneNumber: this.telephoneNumber,
              company: this.company,
              streetAddress: this.streetAddress,
              city: this.city,
              state: this.state,
              zipCode: this.zipCode,
              id: this.id,
              username: this.username,
              email: this.email,
              defaultTemplateGroup: this.defaultTemplateGroup
            };
          }

          this.$http.put(url, data, {
            headers: {
              'content-type': 'application/json'
            }
          }).then(function (response) {
            if (response.data.result === "SUCCESSFUL") {
              let message = `Account information updated successfully.`;
              self.$toasted.show(message,
                  {
                    containerClass: 'super-toasty',
                    iconPack: 'fontawesome',
                    closeOnSwipe: true,
                    action: {
                      text: 'DISMISS',
                      onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                      }
                    },
                    icon: {
                      name: 'fa-check-circle',
                      after: false,
                    }
                  })
                  .goAway(5000);
            } else {
              let message = `${response.data.message}`;
              self.$toasted.show(message,
                  {
                    containerClass: 'super-toasty',
                    iconPack: 'fontawesome',
                    closeOnSwipe: true,
                    action: {
                      text: 'DISMISS',
                      onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                      }
                    },
                    icon: {
                      name: 'fa-skull-crossbones',
                      after: false,
                    }
                  })
                  .goAway(5000);
            }
          }).catch(function (error) {
            let message = `Update failed with error: ${error.message}`;
            self.$toasted.show(message,
                {
                  containerClass: 'super-toasty',
                  iconPack: 'fontawesome',
                  closeOnSwipe: true,
                  action: {
                    text: 'DISMISS',
                    onClick: (e, toastObject) => {
                      toastObject.goAway(0);
                    }
                  },
                  icon: {
                    name: 'fa-skull-crossbones',
                    after: false,
                  }
                })
                .goAway(5000);
          });
        },
        cancel: function () {
          this.$router.push({path: '/my-account'});
        }
      }
}
</script>

<style scoped>
.cancel-button {
  margin-left: 10px;
  margin-top: 5px;
}

.submit-button {
  margin-left: 10px;
  margin-top: 5px;
}

.button-holder {
  horiz-align: center;
  display: flex; /*Requires vendor prefixes*/
  justify-content: center; /*Requires vendor prefixes*/
  align-items: center; /*Requires vendor prefixes*/
}
</style>
